(() => {
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-ms-quality-zoom]');
    if (!opener) return;
    const section = opener.closest('.ms-quality');
    const dialog = section?.querySelector('[data-ms-quality-dialog]');
    if (!dialog) return;
    const image = dialog.querySelector('[data-ms-quality-dialog-image]');
    const caption = dialog.querySelector('[data-ms-quality-dialog-caption]');
    image.src = opener.dataset.image || '';
    image.alt = opener.dataset.caption || '';
    caption.textContent = opener.dataset.caption || '';
    dialog.showModal();
  });
})();
